module.exports = __webpack_public_path__ + "img/screenfull-error.b54bfa90.png";